// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageAsset_container__STRB0","absolute":"ImageAsset_absolute__qtpNH","cover":"ImageAsset_cover__KA1w_","boarderRadius":"ImageAsset_boarderRadius__Qy20z"};